import { useController, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Preview from "./Preview";
import { firstToUpper } from "../../../../../../../utils/helpers/string";
import { cn } from "../../../../../../../lib/utils";
import { palette, shiftTypes } from "./colors";

function ShiftColorField({ fieldName, paletteKey, label, isDashed, caseDisplay }: any) {
    const { control } = useFormContext();
    const { field } = useController({ control, name: fieldName });
    const options = palette[paletteKey];
    const selected: number = field.value ?? 0;
    const { bg, border } = options[selected] ?? options[0];

    return (
        <div className="tw-flex tw-items-center tw-gap-3 tw-py-2.5 tw-border-b tw-border-border last:tw-border-0">
            <span className="tw-text-sm tw-text-foreground tw-w-24 tw-shrink-0">{label}</span>
            <div className="tw-flex tw-gap-1.5 tw-shrink-0">
                {options.map((opt: any, i: number) => (
                    <button
                        key={i}
                        type="button"
                        onClick={() => field.onChange(i)}
                        className={cn(
                            "tw-w-5 tw-h-5 tw-rounded-full tw-border tw-transition-all tw-cursor-pointer",
                            selected === i
                                ? "tw-ring-2 tw-ring-offset-1 tw-ring-foreground/60 tw-scale-110"
                                : "hover:tw-scale-110",
                        )}
                        style={{ backgroundColor: opt.bg, borderColor: opt.border }}
                    />
                ))}
            </div>
            <Preview
                bg={bg}
                border={border}
                caseDisplay={caseDisplay}
                label={label}
                isDashed={isDashed}
            />
        </div>
    );
}

function Shift() {
    const { t } = useTranslation();
    const { control } = useFormContext();
    const caseDisplay = useWatch({ control, name: "shiftCaseDisplay" }) ?? "normal";

    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <span className="tw-text-sm tw-font-medium tw-text-foreground">{t("shift-type-colors")}</span>
            <div className="tw-flex tw-flex-col">
                {shiftTypes.map(({ key, fieldName, paletteKey }) => (
                    <ShiftColorField
                        key={key}
                        fieldName={fieldName}
                        paletteKey={paletteKey}
                        label={firstToUpper(t(key))}
                        isDashed={key === "open-shift"}
                        caseDisplay={caseDisplay}
                    />
                ))}
            </div>
        </div>
    );
}

export default Shift;